<template>
  <div class="right_card_wrap">
    <ErrorForm ref="errorFormRef" />
    <TimeForm ref="timeFormRef" />

    <div class="opertion_wrap">
      <div   class="text" v-if="userInfo.show_discuss == 1">
        <img src="@/assets/icons/发帖子.png"
               @click="addDiscuss"
               alt=""
               v-if="userInfo.show_discuss == 1">
               发帖
      </div>
       <div   class="text">
      <img src="@/assets/icons/jc.png"
           @click="jiucuo"
           alt="">
           反馈
      <!-- <img src="@/assets/icons/nz.png"
           alt=""> -->
             </div>
               <div   class="text">
      <img src="@/assets/icons/card.png"
           @click="toCard"
           alt="">
           答题卡
 </div>
      <!-- <img src="@/assets/timeing.png" @click="toSetTime" alt=""> -->
    </div>
    <div v-for="item in topic_numer"
         @click="toMaodian(item)"
         class="item"
         :style="{'background':isActive == item?'#3F9EFF':'#CCCCCC','margin-top':item == 1?'':'12rem'}"
         :key="item">
      {{item }}</div>
        <Form ref="FormRef"  />
  </div>
</template>

<script>
import ErrorForm from './error.vue'
import TimeForm from './time.vue'
import Form from '@/views/discuss/components/form.vue'
import { getBoard } from '@/api/discuss.js'

export default {
  data () {
    return {
      isActive: 1,
      isClick: false,
       userInfo: {},
          boardList: [],
    }
  },
  props: {
    topic_numer: {
      type: Number,
      default: 0
    }
  },
  components: {
    ErrorForm, TimeForm,Form
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.listenerFunction, true)
  },
  mounted () {
    this.$nextTick(() => {
      document.addEventListener('scroll', this.listenerFunction, true);
    })
        this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))

  },
  methods: {
        async addDiscuss () {
      if (this.boardList.length == 0) {
        const { data } = await getBoard()
        this.boardList = data
      }
      let form = {
        board_id: '',
        discuss_title: '',
        discuss_content: '',

        question_id: '',

      }
      this.$refs.FormRef.dialogVisible = true
      this.$refs.FormRef.form = form
    },
    toMaodian (index) {
      this.isActive = index
      this.isClick = true
      let anchorElement = document.getElementsByClassName('yuan')[index - 1];
      if (anchorElement) {
        anchorElement.scrollIntoView({ behavior: 'smooth' });
      }
      let that = this
      setTimeout(() => {
        that.isClick = false
      }, 1500)
    },
    listenerFunction (e) {
      if (!this.isClick) {
        this.$nextTick(() => {
          for (var index = 0; index < this.topic_numer; index++) {
            if (!document.getElementsByClassName('yuan')[index]) {
              document.removeEventListener('scroll', this.listenerFunction)
            }
            var getAttr = document.getElementsByClassName('yuan')[index].getBoundingClientRect()
            if (getAttr.top < 500 && getAttr.top > -500) {
              this.isActive = index + 1
            }
          }
        })
      }

    },
    toCard () {
      this.$parent.toCard()
    },
    jiucuo () {
      let form = {
        question_id: '',
        category: 0,
        comment: '',
      }
      this.$refs.errorFormRef.form = form
      this.$refs.errorFormRef.dialogVisible = true
    },
    toSetTime () {
      if (this.$parent.totalTime != 0) {
        this.$refs.timeFormRef.editTime = false
      }
      this.$refs.timeFormRef.leftTime = Math.round(this.$parent.totalTime/60)
      this.$refs.timeFormRef.totalTime = this.$parent.paperInfo.paper_duration
      this.$refs.timeFormRef.timeDialogVisible = true
    },
    setTimeSubmit (time) {
      this.$parent.totalTime = time*60
      this.$parent.setTimeing(false)
      this.$parent.setTimeing(true)
    },
  }
}
</script>

<style lang="scss" scoped>
.right_card_wrap {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  width: 80rem;
  height: calc(100vh - 120rem);
  overflow-y: scroll;
  position: fixed;
  right: 30rem;
  top: 100rem;
  margin-bottom: 20rem;
  .item {
    width: 44rem;
    height: 44rem;
    border-radius: 50%;
    background: #cccccc;
    display: flex;
    justify-content: center;
    align-content: center;
    color: white;
    font-size: 24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .opertion_wrap {
    position: fixed;
    top: 30rem;
    right: 160rem;
    background: none;
    display: flex;
    gap: 24rem;
    // width: 200rem;
    .text{
      color: var(--2196-f-3, #2196F3);
 display:flex;flex-direction: column;
font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
align-items: center;
    }
    img {
      background: none;
      cursor: pointer;
      width: 48rem;
      height: 48rem;
      // margin-left: 24rem;
    }
  }
}
</style>